import React from "react";
import {
  Box,
  Container,
  Divider,
  makeStyles,
  Paper,
  Typography,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
}));

function PersonalData() {
  const classes = useStyles();

  return (
    <Container maxWidth="lg" className={classes.root}>
      <Paper>
        <Box p={6}>
          <Box mt={2}>
            <Typography gutterBottom variant="h5" color="textPrimary">
              KİŞİSEL VERİLERİN KORUNMASINA İLİŞKİN BİLGİLENDİRME
            </Typography>
            <Box my={2}>
              <Divider />
            </Box>
            <Typography variant="body1" color="text">
              <p>
                6698 sayılı Kişisel Verilerin Korunması Kanunu uyarınca kişisel
                verilerinizle ilgili olarak sizleri bilgilendirmek istiyoruz.
              </p>
              <p>
                Getir Perakende Lojistik A.Ş. (Getir) veri sorumlusu sıfatıyla
                kişisel verilerinizi, uygulamaya kayıt esnasında toplayarak
                üyelik sözleşmenizin kurulması ve ifasıyla doğrudan ilgili
                olmaları nedeniyle işlemektedir.
              </p>
              <p>Getir’in, kişisel verilerinizi işleme amacı:</p>
              <ul>
                <li>(i) Kimliğinizi doğrulamak,</li>
                <li>(ii) Müşteri desteği sağlamak ve sorun gidermek,</li>
                <li>
                  (iii) Servis güncellemeleri ve hatalar hakkında sizi
                  bilgilendirmek,
                </li>
                <li>
                  (iv) Uygulama ile ilgili kampanyalar hakkında sizi
                  bilgilendirmek,
                </li>
                <li>
                  (v) Getir kuryesinin, teslimatla ilgili olarak size ulaşması
                  gerektiğinde sizi arayabilmesini sağlamaktır. (Getir kuryeleri
                  sizi arayabilmekte fakat telefon numaranız Getir kuryelerine
                  iletilmemektedir. Ancak, yemek siparişlerinizde restoranın
                  siparişinizi getirmesi seçeneği ile ilerlediğinizde, telefon
                  numaranız ilgili restoran ve kuryesi ile paylaşılmaktadır.)
                </li>
              </ul>
              <p>
                Kişisel verileriniz yurtiçi ve/veya yurtdışında bulunan güvenli
                sunucularımızda saklanmaktadır.Getir, sözü edilen istisna
                dışında, hukuken gerekli veya yükümlü olmadıkça kişisel
                verilerinizi ve/veya trafik verilerinizi ya da iletişim
                içeriğini sizin açık izniniz olmadan üçüncü kişilere
                aktarmamaktadır.KVKK’da belirlenen ve rıza gerektirmeyen
                hallerin yanı sıra, Getir uygulama vasıtasıyla edinilen
                onayınıza istinaden, size, hizmetlerine ilişkin kampanya ve
                duyurularını iletebilecek ve müşteri memnuniyeti sağlamak
                amacıyla tarafınızla temasa geçebilecektir.
              </p>
              <p>
                Kişisel verilerinizin korunmasına ilişkin haklarınız aşağıda
                belirtilmiştir:
              </p>
              <ul>
                <li>
                  (i) Kişisel verilerinizin işlenip işlenmediğini öğrenmek,
                </li>
                <li>
                  (ii) Kişisel verileriniz işlenmişse buna ilişkin bilgi talep
                  etmek,
                </li>
                <li>
                  (iii) Kişisel verilerinizin hangi amaçla işlendiğini ve bu
                  amaçlara uygun kullanılıp kullanılmadığını öğrenmek,
                </li>
                <li>
                  (iv) Kişisel verilerinizin yurt içinde veya yurt dışında
                  aktarıldığı üçüncü kişileri bilmek,
                </li>
                <li>
                  (v) Kişisel verilerinizin eksik veya yanlış işlenmiş olması
                  halinde bunların düzeltilmesini istemek,
                </li>
                <li>
                  (vi) Kişisel verilerinizin silinmesini veya yok edilmesini
                  talep etmek,
                </li>
                <li>
                  (vii) Düzeltme, silme ve yok etme taleplerinizin kişisel
                  verilerinizin aktarıldığı üçüncü kişilere bildirilmesini
                  istemek, işlenen verilerinizin münhasıran otomatik sistemler
                  vasıtasıyla analiz edilmesi suretiyle şahsınız aleyhine bir
                  sonucun ortaya çıkmasına itiraz etmek,
                </li>
                <li>
                  (viii) Kişisel verilerinizin kanuna aykırı olarak işlenmesi
                  sebebiyle zarara uğramanız halinde zararın giderilmesini talep
                  etmek.
                </li>
              </ul>
              <p>
                Kişisel verilerinizin korunmasına ilişkin her türlü{" "}
                <a href="mailto:talebinizikisiselveriler@getir.com">
                  talebinizikisiselveriler@getir.com
                </a>{" "}
                adresine iletebilirsiniz. Talepleriniz titizlikle
                değerlendirilecek ve tarafınıza en kısa zamanda bir dönüş
                yapılacaktır
              </p>
              <p>
                Kişisel verilerinizin korunmasına ilişkin olarak yukarıda yer
                verilen bilgiler, kullanım koşullarına da eklenmiş olup bu
                bilgilere, Uygulama aracılığıyla her zaman erişebilirsiniz.
              </p>
              <p></p>
              <p></p>
              <p>Saygılarımızla,</p>
            </Typography>
          </Box>
        </Box>
      </Paper>
    </Container>
  );
}

export default PersonalData;
